import { Dialog } from '@apply/components/dialog.js';

export const openDialog = {
  methods: {
    // 新建信息完善提示
    updateMessage() {
      Dialog({
        title: '操作提示',
        dialogFormVisible: true,
        warnInfo: '您需要先完善企业信息，才可新建应用',
        tipStatus: false,
        success: params => {
          console.log(params);
        },
      });
    },
  },
};
